import { __assign, __spreadArrays } from "tslib";
import * as React from 'react';
import { SectionType, SupportedComponents } from './SupportedComponents';
import { composer } from '../../component-decorators/composer';
import { config } from '../../config';
import s from './style.scss';
import { biLogger } from '../../bi';
import { FluidContainer } from '../FluidContainer';
import { HomeHeader } from './partials/home-header/home-header';
import { getReferralInfo, getWidgetReferral } from '../../common/bi-events';
import { VisibilityDetector } from '../visibility-detector/visibility-detector';
import { v4 as generateUuidV4 } from 'uuid';
import { Discovery, discoverySectionDTOtoProps } from './partials/discovery';
import { isAppInstalled } from '../../common/utils';
import { AppMarketPage } from '../../types/common/marketplace';
import { Origin, Path } from '../../enums/marketplace-enums';
import { HeaderHolidaySaleExport } from '@wix/app-market-collection-widget';
import { HolidaySale } from '../holiday-sale/home/holiday-sale';
import { BannerHolidaySale } from '../holiday-sale/home/banner-holiday-sale';
var WIX_STORES_APP_ID = '1380b703-ce81-ff05-f115-39571d94dfcd';
var getImpressionIds = function (sections) {
    return sections.map(function (section) { return generateUuidV4(); });
};
var getDiscoveryInfo = function (sections, experiments, marketplaceStore) {
    var discoverySection = sections.find(function (section) { return section.type === SectionType.DISCOVERY; });
    var showDiscoveryWidget = discoverySection && (experiments === null || experiments === void 0 ? void 0 : experiments.enabled('specs.marketplace.discovery')) &&
        isAppInstalled(WIX_STORES_APP_ID, marketplaceStore);
    return { discoverySection: discoverySection, showDiscoveryWidget: showDiscoveryWidget };
};
function sendPageViewBi(sections, marketplaceStore, showDiscoveryWidget) {
    var _a, _b;
    var sectionsSlugs = sections === null || sections === void 0 ? void 0 : sections.map(function (section) { return section === null || section === void 0 ? void 0 : section.id; });
    var pageViewParams = {
        market: config.originForBI,
        navigation_source: ((_a = marketplaceStore === null || marketplaceStore === void 0 ? void 0 : marketplaceStore.route) === null || _a === void 0 ? void 0 : _a.referral) || 'first_load',
        tag_type: AppMarketPage.HOMEPAGE,
        tag_name: AppMarketPage.HOMEPAGE,
        referral_info: getReferralInfo((_b = marketplaceStore === null || marketplaceStore === void 0 ? void 0 : marketplaceStore.route) === null || _b === void 0 ? void 0 : _b.referral, marketplaceStore.prevRoute),
        widget_referral: getWidgetReferral(),
        slug_index_list: sectionsSlugs === null || sectionsSlugs === void 0 ? void 0 : sectionsSlugs.filter(Boolean).join(','),
        section: showDiscoveryWidget ? 'discovery' : '',
    };
    // tslint:disable-next-line: no-floating-promises
    biLogger.appMarketPageView(pageViewParams);
}
var onClickCtaHolidayBanner = function () {
    config.goto({
        path: Path.CATEGORY,
        slug: 'pre-holiday-sale',
        referral: 'holiday-sale-home',
    });
};
var sendSectionImpressionsBi = function (type, sectionProps, index, impressionIds) {
    var _a;
    if ((type === SectionType.COLLECTION || type === SectionType.PROMO) && ((_a = sectionProps === null || sectionProps === void 0 ? void 0 : sectionProps.webSolutions) === null || _a === void 0 ? void 0 : _a.length)) {
        var appIds = sectionProps === null || sectionProps === void 0 ? void 0 : sectionProps.webSolutions.map(function (webSolution) { return webSolution.id; });
        var appIdsList = appIds === null || appIds === void 0 ? void 0 : appIds.join(',');
        biLogger.appMarketAppCollectionImpressions({
            apps_list: appIdsList,
            number_of_apps: appIds.length,
            collimp_id: impressionIds[index],
            tag_name: sectionProps === null || sectionProps === void 0 ? void 0 : sectionProps.rootTagDefinition.slug,
            tag_type: 'homepage',
            collection_index: index,
        });
    }
};
export var HomeComponentWrapper = composer()
    .withMarketplaceStore()
    .withTranslation()
    .withExperiments()
    .compose(function (props) {
    var notInStandalone = config.origin !== Origin.STANDALONE;
    // tslint:disable-next-line:react-hooks-nesting
    var _a = React.useState(false), showSaleHeader = _a[0], changeShowSaleHeader = _a[1];
    var marketplaceStore = props.marketplaceStore, locale = props.locale, signedInstance = props.signedInstance, fetchData = props.fetchData, isMobile = props.isMobile;
    return (React.createElement(React.Fragment, null,
        notInStandalone && (React.createElement(HeaderHolidaySaleExport, { origin: config.origin, locale: locale, home: true, opacity: showSaleHeader ? 1 : 0, onClick: onClickCtaHolidayBanner, referral: 'home-section', msId: marketplaceStore.metaSiteId })),
        React.createElement(HomeComponent, { fetchData: fetchData, locale: locale, signedInstance: signedInstance, changeShowSaleHeader: changeShowSaleHeader, notInStandalone: notInStandalone, isMobile: isMobile })));
});
export var HomeComponent = composer()
    .withMarketplaceStore()
    .withTranslation()
    .withExperiments()
    .compose(function (props) {
    var marketplaceStore = props.marketplaceStore, t = props.t, locale = props.locale, signedInstance = props.signedInstance, experiments = props.experiments, changeShowSaleHeader = props.changeShowSaleHeader, notInStandalone = props.notInStandalone, isMobile = props.isMobile;
    var fetchData = props.fetchData;
    var sections = fetchData[0].container.sections;
    var ids = getImpressionIds(sections);
    var _a = getDiscoveryInfo(sections, experiments, marketplaceStore), discoverySection = _a.discoverySection, showDiscoveryWidget = _a.showDiscoveryWidget;
    var filteredSections = sections.filter(function (section) { return (section === null || section === void 0 ? void 0 : section.id) !== (discoverySection === null || discoverySection === void 0 ? void 0 : discoverySection.id); });
    // tslint:disable-next-line: react-hooks-nesting
    React.useEffect(function () {
        sendPageViewBi(sections, marketplaceStore, showDiscoveryWidget);
    }, []);
    var showHolidaySale = experiments.enabled('specs.marketplace.blackFridaySale');
    var showNewSaleHomeDesign = experiments.enabled('specs.marketplace.holidaySaleNewDesign');
    var replacePromoBox = experiments.enabled('specs.marketplace.replaceHPboxes');
    var SectionsWrapper = function (_a) {
        var homePageSections = _a.homePageSections, impressionIds = _a.impressionIds;
        var _b = React.useState([]), sectionsWithBi = _b[0], setSectionsWithBi = _b[1];
        var onSectionImpression = function (type, sectionProps, index) {
            if (!sectionsWithBi.includes(index)) {
                // tslint:disable-next-line:no-shadowed-variable
                setSectionsWithBi(function (sectionsWithBi) { return __spreadArrays(sectionsWithBi, [index]); });
                sendSectionImpressionsBi(type, sectionProps, index, impressionIds);
            }
        };
        console.log("marketplace-component/src/components/home/homeComponent.tsx - line 138 - " + Date.now());
        return (React.createElement("div", { className: s.sectionsWrapper }, homePageSections
            .filter(function (section) { return SupportedComponents[section.type]; })
            .map(function (section, i) {
            var type = section.type;
            if ((replacePromoBox) && type === 'PROMO') {
                type = 'COLLECTION';
            }
            var SectionComponent = SupportedComponents[type].component;
            var sectionMapper = SupportedComponents[type].propsMapper;
            var sectionProps = sectionMapper
                ? sectionMapper(section.sectionData, marketplaceStore, locale, signedInstance, impressionIds[i])
                : {};
            return (
            // tslint:disable-next-line:jsx-key
            React.createElement("div", { className: s.sectionWrapper },
                React.createElement(VisibilityDetector, { onVisible: function () {
                        return onSectionImpression(type, sectionProps, i);
                    }, onUnVisible: function () {
                        return '';
                    } },
                    React.createElement(SectionComponent, __assign({ key: i }, sectionProps)))));
        })));
    };
    console.log("marketplace-component/src/components/home/homeComponent.tsx - line 176 - " + Date.now());
    var top = notInStandalone && showHolidaySale
        ? showNewSaleHomeDesign
            ? '-100px'
            : '-73px'
        : '0';
    var showHeaderForSale = !(showNewSaleHomeDesign && config.origin === Origin.BIZMGR);
    return (React.createElement("div", { "data-hook": "homepage", "data-testit": "homepage", style: { position: 'relative', top: top } },
        showDiscoveryWidget && !showHolidaySale && (React.createElement(Discovery, { tagsToWebSolutions: discoverySectionDTOtoProps(discoverySection.sectionData), impressionId: ids[0] })),
        React.createElement(FluidContainer, null, !showDiscoveryWidget && showHeaderForSale && React.createElement(HomeHeader, null)),
        !isMobile && showHolidaySale && (React.createElement(HolidaySaleSection, { changeShowSaleHeader: changeShowSaleHeader, market: config.originForBI, showNewSaleHomeDesign: showNewSaleHomeDesign })),
        React.createElement(FluidContainer, null,
            React.createElement(SectionsWrapper, { homePageSections: filteredSections, impressionIds: ids }))));
});
var HolidaySaleSection = composer().compose(function (_a) {
    var changeShowSaleHeader = _a.changeShowSaleHeader, market = _a.market, showNewSaleHomeDesign = _a.showNewSaleHomeDesign;
    return (React.createElement(React.Fragment, null,
        React.createElement(VisibilityDetector, { onVisible: function () { return changeShowSaleHeader(false); }, onUnVisible: function () { return changeShowSaleHeader(true); } }, showNewSaleHomeDesign && config.origin === Origin.BIZMGR ? (React.createElement(BannerHolidaySale, null)) : (React.createElement(HolidaySale, { market: market })))));
});
//# sourceMappingURL=homeComponent.js.map